enum ClassTypeIds {
  FullTimeId = 1,
  PartTimeId = 2,
  SalariedId = 3,
  HourlyId = 4,
  ExecutiveId = 5,
  ManagerId = 6,
  StaffId = 7,
  AllEligibleEmployeesId = 8,
  NonSalaried = 9,
  Seasonal = 10,
}

export default ClassTypeIds

export const unPairableClassTypes = new Map<number, number[]>()
unPairableClassTypes.set(ClassTypeIds.FullTimeId, [ClassTypeIds.AllEligibleEmployeesId, ClassTypeIds.PartTimeId])
unPairableClassTypes.set(ClassTypeIds.PartTimeId, [ClassTypeIds.AllEligibleEmployeesId, ClassTypeIds.FullTimeId])
unPairableClassTypes.set(ClassTypeIds.SalariedId, [ClassTypeIds.AllEligibleEmployeesId, ClassTypeIds.NonSalaried])
unPairableClassTypes.set(ClassTypeIds.HourlyId, [ClassTypeIds.AllEligibleEmployeesId])
unPairableClassTypes.set(ClassTypeIds.ExecutiveId, [ClassTypeIds.AllEligibleEmployeesId])
unPairableClassTypes.set(ClassTypeIds.ManagerId, [ClassTypeIds.AllEligibleEmployeesId])
unPairableClassTypes.set(ClassTypeIds.StaffId, [ClassTypeIds.AllEligibleEmployeesId])
unPairableClassTypes.set(ClassTypeIds.NonSalaried, [ClassTypeIds.AllEligibleEmployeesId, ClassTypeIds.SalariedId])
unPairableClassTypes.set(ClassTypeIds.Seasonal, [ClassTypeIds.AllEligibleEmployeesId])
unPairableClassTypes.set(ClassTypeIds.AllEligibleEmployeesId, [
  ClassTypeIds.FullTimeId,
  ClassTypeIds.PartTimeId,
  ClassTypeIds.SalariedId,
  ClassTypeIds.NonSalaried,
  ClassTypeIds.HourlyId,
  ClassTypeIds.ExecutiveId,
  ClassTypeIds.ManagerId,
  ClassTypeIds.StaffId,
  ClassTypeIds.Seasonal,
])

export const canClassTypeBePairedWith = (classTypeId: number, pairWithClassTypeId: number): boolean => {
  const unPairable = unPairableClassTypes.get(classTypeId)
  return unPairable ? !unPairable.some((x) => x === pairWithClassTypeId) : true
}
